// @ts-ignore
import FileUploader from 'react-firebase-file-uploader'

import { makeStyles, CircularProgress } from '@material-ui/core'

import { AttachFile as FileIcon } from '@material-ui/icons'

import { useAuth, useBoolean } from 'hooks'

import { envConfig } from 'modules'

import firebase from 'firebase/app'
import { useState } from 'react'

const useStyles = makeStyles({
    wrapper: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginRight: '10px',
        padding: '0'
    },
    label: {
        margin: '-5px -15px',
        padding: '5px 15px',
        color: '#2D9CDB'
    },
    fileIcon: {
        color: '#2D9CDB'
    }
})

type Props = {
    playbookId: string
    callback?: (url: string) => any
}

const ALLOWED_FORMATS = '.srt,.vtt'

export const SubtitleUploader = ({ playbookId, callback }: Props) => {
    const classes = useStyles()
    const loading = useBoolean()
    const { uid } = useAuth()
    const [fileName, setFileName] = useState('')
    const storageRef = firebase
        .app()
        .storage(`gs://${envConfig.firebaseConfig.projectId}-temporary`)
        .ref(`uploads/${uid}/${playbookId}`)

    const handleUploadSuccess = (name: string) => {
        setFileName(name)
        storageRef
            .child(name)
            .getDownloadURL()
            .then((url: string) => {
                loading.setFalse()
                callback?.(url)
            })
    }

    return (
        <label className={classes.wrapper} data-cy="file-uploader-wrapper">
            {loading.isTrue && <CircularProgress size={14} />}
            <FileUploader
                hidden
                name="subtitleUploader"
                accept={ALLOWED_FORMATS}
                metadata={{ cacheControl: 'max-age=604800' }}
                storageRef={storageRef}
                onUploadStart={loading.setTrue}
                onUploadSuccess={handleUploadSuccess}
                data-cy="file-uploader"
            />
            <FileIcon fontSize="small" className={classes.fileIcon} data-cy="file-icon" />
            {fileName || 'Upload'}
        </label>
    )
}
